import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DependOnOption, DisabledType } from '../common'

export class UploadDef {
  key?: string = uuid()
  type: 'upload' = 'upload'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: UploadOptions = new UploadOptions()
  rules?: Rule[]
}

export class UploadOptions {
  defaultValue?: FileData[] = []
  disabled?: DisabledType = false
  labelWidth?: string | number
  required?: boolean = false
  action?: string = ''
  resp?: (response: any) => FileData
  request?: UploadRequest
  type?: 'card' | 'list' = 'card'
  accept?: string
  limit?: number
  maxSize?: string
  tip?: string
  beforeUpload?: (file: any, fileList: any[]) => boolean | Promise<any>
  inline?: boolean
  multiple?: boolean
}

interface UploadRequestOptions {
  headers: Record<string, any>;
  withCredentials: boolean;
  file: File;
  data: any;
  filename: string;
  action: string;
  onProgress: (e: { percent: number }) => void;
  onSuccess: (res: any) => void;
  onError: (err: Error) => void;
}

interface UploadRequest {
  (options: UploadRequestOptions): UploadRequest;
}

interface FileData {
  name: string;
  url: string;
  uid?: number;
  status?: 'ready' | 'uploading' | 'success' | 'fail';
}
